import React, { useRef, useState, useEffect } from 'react';

const CategoryTabs = ({ categories, selectedCategory, onSelectCategory, fromKiosk = false }) => {
  const navRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkScrollPosition = () => {
    if (!navRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = navRef.current;
    setShowLeftArrow(scrollLeft > 0);
    setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
  };

  useEffect(() => {
    checkScrollPosition();
    const container = navRef.current;
    if (container) {
      container.addEventListener('scroll', checkScrollPosition);
      window.addEventListener('resize', checkScrollPosition);
      return () => {
        container.removeEventListener('scroll', checkScrollPosition);
        window.removeEventListener('resize', checkScrollPosition);
      };
    }
  }, [categories]);

  useEffect(() => {
    if (!navRef.current) return;
    const activeButton = navRef.current.querySelector('[data-active="true"]');
    if (activeButton) {
      activeButton.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [selectedCategory?.Category]);

  const scroll = (direction) => {
    if (!navRef.current) return;
    navRef.current.scrollBy({
      left: direction === 'left' ? -200 : 200,
      behavior: 'smooth',
    });
  };

  if (categories.length === 0) return null;

  return (
    <nav
      className={`sticky z-20 bg-white ${
        fromKiosk ? '!top-[0px] md:!top-[0px]' : '!top-[47px] md:!top-[50px]'
      }`}
    >
      <div className="relative">
        {showLeftArrow && (
          <>
            <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
            <button
              onClick={() => scroll('left')}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-20 p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
            >
              <i className="fa fa-chevron-left text-sm sm:text-base text-gray-500" />
            </button>
          </>
        )}

        {showRightArrow && (
          <>
            <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
            <button
              onClick={() => scroll('right')}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-20 p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
            >
              <i className="fa fa-chevron-right text-sm sm:text-base text-gray-500" />
            </button>
          </>
        )}

        <div ref={navRef} className="flex space-x-1 sm:space-x-2 overflow-x-auto scrollbar-hide">
          {categories.map((category) => {
            const isActive = selectedCategory?._id === category._id;

            return (
              <button
                key={category._id}
                data-active={isActive}
                onClick={() => onSelectCategory(category)}
                className={`
                  inline-flex flex-col items-center px-2 py-1 sm:!px-4 sm:!py-2 transition-all border-b-2 border-b-[transparent]
                  hover:bg-gray-100 flex-shrink-0
                  ${isActive ? '!border-b-primary' : ''}
                `}
                style={{
                  minWidth: Math.max(100, category.Category.length * 8),
                }}
              >
                <span
                  className={`
                    text-sm sm:text-base font-semibold mb-1
                    ${isActive ? 'text-primary' : 'text-gray-700'}
                  `}
                >
                  {category.Category}
                </span>
                {!fromKiosk && (category?.start || category?.end) && (
                  <span className="text-xs sm:text-sm text-gray-500">
                    {`${category?.start}-${category?.end === '23:59' ? '00:00' : category?.end}`}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default CategoryTabs;
